import ActionColumn from "../components/atoms/action-column/action-column";

/**
 * Creates an action column definition for AG Grid.
 *
 * @param {object}   options
 * @param {function} options.t        - Translation function
 * @param {Array}    options.actions  - Action definitions ({ label, onClick, permission?, show?, danger? })
 * @param {number}   [options.maxWidth=100]
 */
export const createActionColumn = ({ t, actions, maxWidth = 100 }) => ({
	headerName: t("common.action"),
	headerTooltip: t("common.action"),
	sortable: false,
	resizable: false,
	maxWidth,
	minWidth: 30,
	cellRenderer: ({ data, rowIndex, context }) => {
		if (!data) return null;
		return (
			<ActionColumn
				t={t}
				actions={actions}
				data={data}
				rowIndex={rowIndex}
				context={context}
			/>
		);
	},
});
